export const soapEntryRootSx = {
  width: '100%'
};

export const visitDateRowSx = {
  px: 1.5,
  pt: 1.5,
  display: 'flex',
  alignItems: 'flex-start',
  gap: 2
};

export const pastButtonWrapperSx = {
  mt: 1,
  display: 'flex',
  justifyContent: 'flex-end'
};

export const pastButtonSx = {
  p: 0.25,
  color: '#424242',

  '&:hover': {
    color: '#1976D2',
    bgcolor: 'transparent'
  }
};

export const pastButtonIconSx = {
  fontSize: 18
};

export const sectionSx = {
  p: 1.5
};

export const sectionHeaderSx = {
  mb: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
};

export const sectionTitleSx = {
  color: '#424242',
  fontSize: 13,
  fontWeight: 600
};

export const vsHxLinkSx = {
  p: 0,
  border: 0,
  cursor: 'pointer',
  fontFamily: 'Roboto',
  fontSize: 12,
  fontWeight: 500,
  textDecoration: 'underline',

  '&:hover': {
    textDecoration: 'underline'
  }
};

export const vitalsGridSx = {
  width: '100%',
  display: 'grid',
  gridTemplateColumns: {
    xs: 'repeat(2, minmax(0, 1fr))',
    sm: 'repeat(4, minmax(0, 1fr))',
    md: 'repeat(7, minmax(0, 1fr))'
  },
  gap: 1
};

export const vitalFieldSx = {
  minWidth: 0,

  '& .MuiOutlinedInput-root': {
    height: 34,
    color: '#757575',
    fontSize: 12
  },

  '& .MuiInputLabel-root': {
    color: '#757575',
    fontSize: 11
  },

  '& .MuiInputLabel-root.Mui-focused': {
    color: '#4A90D9'
  }
};

export const templateSectionSx = {
  p: 1.5,
  position: 'relative'
};

export const templateButtonWrapperSx = {
  mb: 1.5,
  display: 'flex',
  justifyContent: 'flex-end'
};

export const templateButtonSx = {
  fontSize: 11
};

export const templateButtonIconSx = {
  mr: 0.5,
  fontSize: 14
};

export const assessmentWrapperSx = {
  px: 1.5
};

export const assessmentActionsSx = {
  mb: 1.5,
  display: 'flex',
  flexWrap: 'wrap',
  gap: 1
};

export const assessmentPlanActionsSx = {
  mb: 1.5,
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 1
};

export const footerSx = {
  px: 1.5,
  py: 2,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: 1,
  borderTop: '1px solid #E0E0E0',
  bgcolor: '#FFFFFF'
};

export const assessmentButtonStyles = {
  common: {
    minWidth: 32,
    borderRadius: 1,
    fontSize: 12,
    fontWeight: 400,
    textTransform: 'uppercase',
    whiteSpace: 'nowrap'
  },

  rx: {
    color: '#424242',
    bgcolor: '#F8F1E2',
    borderColor: '#EFDCB5',

    '&:hover': {
      bgcolor: '#FFF3D6',
      borderColor: '#D8B66F'
    }
  },

  blue: {
    color: '#424242',
    bgcolor: '#E6F2F9',
    borderColor: '#C1DEF2',

    '&:hover': {
      bgcolor: '#E3F2FD',
      borderColor: '#8FC2E8'
    }
  },

  lightblue: {
    color: '#424242',
    bgcolor: '#E6F2F9',
    borderColor: '#C1DEF2',

    '&:hover': {
      bgcolor: '#E3F2FD',
      borderColor: '#8FC2E8'
    }
  },

  gray: {
    color: '#424242',
    bgcolor: '#EEEEEE',
    borderColor: '#E0E0E0',

    '&:hover': {
      bgcolor: '#EEEEEE',
      borderColor: '#BDBDBD'
    }
  }
};